import { render, staticRenderFns } from "./ProductDropdownRightPanel.vue?vue&type=template&id=39603144&scoped=true"
import script from "./ProductDropdownRightPanel.vue?vue&type=script&lang=js"
export * from "./ProductDropdownRightPanel.vue?vue&type=script&lang=js"
import style0 from "./ProductDropdownRightPanel.vue?vue&type=style&index=0&id=39603144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39603144",
  null
  
)

export default component.exports